export default class informationBox {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                content: '=',
                type: '='
            },
            template: require('../../../../views/directives/information-box.html'),
            controller: [
                '$scope', '$element', '$attrs',
                (scope, element, attrs) => {
                var type = scope.type ? scope.type : 'info';
                element.addClass(type);
            }]
        }
    }
}